<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation
    @submit.prevent="createUser"
  >
    <v-card>
      <v-card-title primary-title>
        Skapa användare från csv
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col>
              <p>
                Klistra in CSV med användare.
              </p>
              <p>Lösenordet för användarna sätts som: <strong>12345</strong></p>
              <v-textarea
                filled
                :placeholder="
                  'exempel.1@email.se;John;Karlsson' +
                    '\u000A' +
                    'exempel.2@email.se;Anna;Svensson'
                "
                ref="textarea"
                label="CSV"
                v-model="model.csv"
                :rules="[rules.required]"
              ></v-textarea>
              <p v-if="csvError" class="error--text">
                Det finns fel i CSV formateringen, kontrollera så allt ser rätt
                ut!
              </p>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn tile text @click="close" :disabled="pendingCreate">
          Avbryt
        </v-btn>
        <v-btn tile color="primary" text type="submit" :loading="pendingCreate">
          Skapa
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import rules from '@/common/validationRules.js'
import gql from 'graphql-tag'
import Papa from 'papaparse'

export default {
  name: 'UserCreateFromCsv',

  data: () => ({
    pendingCreate: false,
    valid: true,
    csvError: false,
    rules,
    model: {
      csv: ''
    }
  }),

  methods: {
    parseCsvString(csvString) {
      this.csvError = false
      const parsedCsv = Papa.parse(csvString.replace(/^\s+|\s+$/g, ''))

      if (parsedCsv.errors.length) {
        return (this.csvError = true)
      }

      return parsedCsv.data.map(x => {
        const [email, first_name, last_name] = x

        return {
          email,
          first_name,
          last_name
        }
      })
    },
    close() {
      this.$emit('close')
    },

    async createUser() {
      const isValid = await this.$refs.form.validate()

      if (!isValid) return

      this.pendingCreate = true
      const payload = this.parseCsvString(this.model.csv)

      if (this.csvError) {
        this.pendingCreate = false
        return
      }

      await this.$apollo.mutate({
        mutation: gql`
          mutation createUserBatch($payload: [CreateUserInput]!) {
            createUserBatch(payload: $payload) {
              id
            }
          }
        `,

        variables: {
          payload
        }
      })

      this.pendingCreate = false
      this.$emit('confirm')
    }
  }
}
</script>
